const MEMBERS = [
  ["Cynthia Bossard", "President", "/family/cynthia.jpg", "Graduate of MIT and Johns Hopkins Universities, specializing in Math and Systems Engineering."],
  ["Mary Bossard", "Vice President", "/family/mary.jpg", "Brings a wealth of marketing and business-ownership experience as an entrepreneur since business school."],
  ["Clifford Bossard", "Secretary", "/family/clifford.jpg", "Graduate of Yale and Korea Universities with deep knowledge in international relations and real estate."],
  ["Ken Bossard", "Treasurer", "/family/ken.jpg", "MBA in Real Estate Development and 40+ years in mortgage finance and real estate sales."],
];

export const FamilyPanel = () => (
  <div className="h-full w-full bg-[#0d1220] px-5 py-8 sm:px-8 sm:pt-9 sm:pb-16 flex flex-col justify-center" data-testid="family-panel">
    <div className="text-center">
      <h3 className="font-serif text-3xl sm:text-4xl text-ivory leading-tight">
        Meet the <span className="text-gold">Bossard Family</span>
      </h3>
      <p className="mt-2 text-xs sm:text-sm text-ivory/55 max-w-sm mx-auto leading-relaxed">
        The people behind every successful deal — serving the DC metro area with integrity since day one.
      </p>
    </div>
    <ul className="mt-6 grid grid-cols-2 sm:grid-cols-4 gap-3">
      {MEMBERS.map(([name, role, src, bio], i) => (
        <li key={name} className="group border border-gold/20 bg-obsidian/70 overflow-hidden" data-testid={`family-panel-member-${i}`}>
          <div className="aspect-[4/3] overflow-hidden">
            <img src={src} alt={name} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" loading="lazy" />
          </div>
          <div className="p-3">
            <div className="font-serif text-sm sm:text-base text-ivory leading-tight">{name}</div>
            <div className="mt-1 font-mono text-[9px] tracking-[0.15em] uppercase text-gold/80">{role}</div>
            <p className="mt-2 hidden lg:block text-[11px] leading-snug text-ivory/50">{bio}</p>
          </div>
        </li>
      ))}
    </ul>
  </div>
);
